<div
    class="ra-viewer-text-wrapper notranslate"
    translate="no"
    [style.--font-family]="fontFamily()"
    [style.fontFamily]="fontFamily()"
>
    <quill-view
        [theme]="'snow'"
        [format]="'json'"
        [content]="contentJson"
        (onEditorCreated)="onEditorCreated($event)"
    />
</div>
